// ============================================================
// multiSelect.ts
// Knockout の options/selectedOptions と併用するカスタムバインディング
// `tomSelect` を、一覧選択モーダル (select-picker.ts) に置き換える。
// 呼び出し側 (Razor) のマークアップは従来どおり:
//   <select multiple
//           data-bind="options:Type1List,
//                      optionsText:'TypeName',
//                      optionsValue:'TypeId',
//                      selectedOptions:SearchType1Ids,
//                      tomSelect:{ placeholder: Type1Name }"></select>
// ============================================================

import { attachSelectPicker, refreshSelectPicker } from './select-picker';

declare const ko: any;

interface PickerBindingOptions {
    placeholder?: string;
    plugins?: string[];
    // 真値で disabled になる。observable / computed / 単純式いずれも可
    disable?: boolean | (() => boolean);
}

ko.bindingHandlers.tomSelect = {
    init(
        element: HTMLSelectElement,
        valueAccessor: () => PickerBindingOptions,
        allBindings: any,
    ) {
        // KO の options / selectedOptions バインディング処理が終わってから差し替える
        setTimeout(() => {
            const opts = ko.utils.unwrapObservable(valueAccessor()) || {};
            const placeholder = ko.utils.unwrapObservable(opts.placeholder) ?? '';
            element.dataset.selectPickerTitle = placeholder;
            element.dataset.selectPickerPlaceholder = placeholder;
            attachSelectPicker(element);

            // disable オプションを監視して select 自体に反映する
            const disableComputed = ko.computed(() => {
                const current = ko.utils.unwrapObservable(valueAccessor()) || {};
                return !!ko.utils.unwrapObservable(current.disable);
            });
            const applyDisabled = (isDisabled: boolean) => { element.disabled = isDisabled; };
            applyDisabled(disableComputed());
            const disableSub = disableComputed.subscribe(applyDisabled);

            // 選択肢・選択値が KO 側で変わったらボタン表示を合わせ直す
            const subscriptions = [disableSub];
            for (const name of ['options', 'selectedOptions']) {
                const observable = allBindings.get(name);
                if (ko.isObservable(observable)) {
                    subscriptions.push(observable.subscribe(() =>
                        setTimeout(() => refreshSelectPicker(element), 0)));
                }
            }

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                subscriptions.forEach(sub => sub.dispose());
                disableComputed.dispose();
            });
        }, 0);

        return { controlsDescendantBindings: false };
    },
};

export {};
